import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginLeft: '2rem',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '45px'
  },
  topicGroup: {
    color: theme.palette.primary.main,
    marginTop: '1.5rem',
    fontWeight: 700,
    fontSize: 14,
    textTransform: 'uppercase',
  },
  subtopicGroup: {
    color: theme.palette.primary.main,
    marginLeft: '1rem',
    fontWeight: 600,
    fontSize: 14,
    textTransform: 'none',
  },
  indicatorGroup: {
    color: '#333',
    marginBottom: '1.0rem',
    marginLeft: '2rem',
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'none',
  },
  commentLine: {
    display: 'flex',
    alignItems: 'center',
    color: 'black',
    marginLeft: '1rem',
    fontWeight: 400,
    fontSize: 12,
    wordBreak: 'break-word',
    textTransform: 'none',
    '& input': {
      marginRight: '0.5rem'
    }
  }
}))
